import { useRef, ReactNode } from "react";
//------------------------------------------
import { cssjson } from "src/components/common/types";
//------------------------------------------
export default function Popover({
    className, 
    style, 
    content, 
    fullContent, ...rest
}:{
    className: string, 
    style: cssjson, 
    content: ReactNode,
    fullContent: ReactNode
}){
    const contentRef = useRef<HTMLSpanElement>(null);
    return (
        <div className = {`mypopover ${className}`} style = {style}
            onMouseOver = {() => {
                contentRef.current?.classList.add("show");
            }} 
            onMouseOut = {() => {
                contentRef.current?.classList.remove("show");
            }}
            {...rest}
        >
            {content}
            <span ref = {contentRef} className = "mypopovertext">{fullContent}</span>
        </div>
    )
}
